import { UserState } from '@juvare/platform-sdk-react/types';
import { createAppContext } from '@juvare/platform-sdk-react/ui/providers';

export const AppContext = createAppContext<UserState>();
